import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.development';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeliveryShiprocketService {

  constructor(private http: HttpClient) { }
 
  // deliveryshiprocket(para:any): Observable<any> {
  //   const token = localStorage.getItem("token") as any;
  //   // // console.log('delivery couriers'  )
  //   // const d = JSON.parse(token as any)
  //   const headers = new HttpHeaders({
  //     'Access-Control-Allow-Origin': '*',
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${token}`
  //   });
  //   const url = `${environment.deliveryapiBaseUrl+environment.apiEndPoint.checkSeviceAbailbility}`;
  //   return this.http.get(url, {headers}, para);
  // }

  deliveryshiprocket(params: any): Observable<any> {
    // const token = localStorage.getItem("token") as string;
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjQ3MDEyNjAsInNvdXJjZSI6InNyLWF1dGgtaW50IiwiZXhwIjoxNzIyMzQwMDczLCJqdGkiOiJaejFnNWZEaE14c2wzZjhsIiwiaWF0IjoxNzIxNDc2MDczLCJpc3MiOiJodHRwczovL3NyLWF1dGguc2hpcHJvY2tldC5pbi9hdXRob3JpemUvdXNlciIsIm5iZiI6MTcyMTQ3NjA3MywiY2lkIjoyODU2NTY0LCJ0YyI6MzYwLCJ2ZXJib3NlIjpmYWxzZSwidmVuZG9yX2lkIjowLCJ2ZW5kb3JfY29kZSI6IiJ9.i_SyYeV6dHulBsDoSqOtUR2oSs7n4Y8TSfarImZavXs'
    
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  
    // Create HttpParams object from the provided params
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
  
    const url = `${environment.deliveryapiBaseUrl + environment.apiEndPoint.checkSeviceAbailbility}`;
  
    return this.http.get(url, { headers, params: httpParams });
  }


  createCustomOrder(param: any): Observable<any> {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjQ3MDEyNjAsInNvdXJjZSI6InNyLWF1dGgtaW50IiwiZXhwIjoxNzIyNDkxMTc5LCJqdGkiOiJOWHpHRXpWdXFFTkhlaWpCIiwiaWF0IjoxNzIxNjI3MTc5LCJpc3MiOiJodHRwczovL3NyLWF1dGguc2hpcHJvY2tldC5pbi9hdXRob3JpemUvdXNlciIsIm5iZiI6MTcyMTYyNzE3OSwiY2lkIjoyODU2NTY0LCJ0YyI6MzYwLCJ2ZXJib3NlIjpmYWxzZSwidmVuZG9yX2lkIjowLCJ2ZW5kb3JfY29kZSI6IiJ9.eBc49L485VSRky94JCUkNbxmDDYlOVCbmZTm5RSEsio';
    // const d = JSON.parse(token as any)
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    const url = `${environment.deliveryapiBaseUrl+environment.apiEndPoint.createCustomOrder}`;
    return this.http.post(url, param, {headers});
  }

  

  trackingOrder(para: any): Observable<any> {
    // const token = localStorage.getItem("token") as string;
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjQ3MDEyNjAsInNvdXJjZSI6InNyLWF1dGgtaW50IiwiZXhwIjoxNzIyMzQwMDczLCJqdGkiOiJaejFnNWZEaE14c2wzZjhsIiwiaWF0IjoxNzIxNDc2MDczLCJpc3MiOiJodHRwczovL3NyLWF1dGguc2hpcHJvY2tldC5pbi9hdXRob3JpemUvdXNlciIsIm5iZiI6MTcyMTQ3NjA3MywiY2lkIjoyODU2NTY0LCJ0YyI6MzYwLCJ2ZXJib3NlIjpmYWxzZSwidmVuZG9yX2lkIjowLCJ2ZW5kb3JfY29kZSI6IiJ9.i_SyYeV6dHulBsDoSqOtUR2oSs7n4Y8TSfarImZavXs'
    
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  
    // Create HttpParams object from the provided params
    
    const url = `${environment.deliveryapiBaseUrl + environment.apiEndPoint.trackingOrder}${para}`;
  
    return this.http.get(url, { headers});
  }

  


}

